import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import "./CaregiverActivityBadge.css";

export const CAREGIVER_ACTIVITY_WINDOW_ROWS = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "90d", label: "90d" },
  { key: "180d", label: "180d" },
  { key: "360d", label: "360d" },
];

/**
 * Small icon-badge trigger for a client table row, placed next to the AIP
 * chip. The popover itself is rendered by the parent (fixed-position, at
 * the top of the DOM tree) via `CaregiverActivityFlyout` — matching the
 * existing kebab-menu pattern in FolderView.js so it isn't clipped by the
 * table's scroll container.
 */
const CaregiverActivityBadge = ({ activity, loading, onToggle }) => {
  const totalVisits90d = activity?.["90d"]?.visitCount ?? 0;

  return (
    <button
      type="button"
      className="ca-badge-trigger"
      title="Caregiver Activity"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        onToggle?.(rect);
      }}
    >
      <FontAwesomeIcon icon={faUsers} />
      {!loading && <span className="ca-badge-count">{totalVisits90d}</span>}
    </button>
  );
};

/**
 * Fixed-position popover content, rendered once by the parent (not once
 * per row) and positioned via the trigger's bounding rect.
 */
export const CaregiverActivityFlyout = ({ activity, loading, left, top }) => (
  <div className="ca-badge-flyout" style={{ position: "fixed", left, top }}>
    <div className="ca-badge-popover-title">Caregiver Activity</div>
    {loading ? (
      <div className="ca-badge-popover-loading">Loading…</div>
    ) : (
      <table className="ca-badge-table">
        <thead>
          <tr>
            <th>Window</th>
            <th>Visits</th>
            <th>Days</th>
            <th>Caregivers</th>
          </tr>
        </thead>
        <tbody>
          {CAREGIVER_ACTIVITY_WINDOW_ROWS.map((w) => {
            const row = activity?.[w.key] || {
              visitCount: 0,
              daysWithVisit: 0,
              caregiverCount: 0,
            };
            return (
              <tr key={w.key}>
                <td>{w.label}</td>
                <td>{row.visitCount}</td>
                <td>{row.daysWithVisit}</td>
                <td>{row.caregiverCount}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )}
  </div>
);

export default CaregiverActivityBadge;
